import { render, staticRenderFns } from "./AdvanceSummary.vue?vue&type=template&id=1681a455&scoped=true&"
import script from "./AdvanceSummary.vue?vue&type=script&lang=js&"
export * from "./AdvanceSummary.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceSummary.vue?vue&type=style&index=0&id=1681a455&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681a455",
  null
  
)

export default component.exports